// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tYjOPB8ZItkeFi5xRriA h3 {
    margin-bottom: 30px;
}

.tYjOPB8ZItkeFi5xRriA .MuiIcon-root {
    font-size: 20px;
}

/* material table heading */
.tYjOPB8ZItkeFi5xRriA h6 {
    font-size: 18px;
    font-weight: 600;
    color: #32445A;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/admin/feature-flags/styles.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA,2BAA2B;AAC3B;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":[".container h3 {\n    margin-bottom: 30px;\n}\n\n.container :global(.MuiIcon-root) {\n    font-size: 20px;\n}\n\n/* material table heading */\n.container h6 {\n    font-size: 18px;\n    font-weight: 600;\n    color: #32445A;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `tYjOPB8ZItkeFi5xRriA`
};
export default ___CSS_LOADER_EXPORT___;
